<template>
  <el-dialog
    :visible="visible"
    top="0"
    custom-class="download-error-dialog"
    :before-close="handleClose"
    :append-to-body="true"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    width="560px"
    center
  >
    <i class="el-icon-close dialog-close-btn" data-io-click="tracker"  @click.stop="handleClose"></i>
    <div slot="title" class="dialog-title tabheader">
      <i class="iconfont icon-info-circle-filled"></i><span>提示</span>
    </div>
    <div class="dialog-body">
      <p class="body-content" v-if="type != 4">{{ message }}</p>
      <p class="body-content" v-else>
        亲爱的用户，为了保证您的帐号安全，请您<span>微信扫码并确认授权</span>后继续尊享网校通服务。
      </p>
      <div
        v-if="type == 2 || type == 3"
        class="submit-btn"
        data-io-click="tracker"  @click="handleJumpPage"
      >
        {{ type == 2 ? "获取专属帐号" : "设置课程入口" }}
      </div>
      <div class="tip" v-if="type == 2 || type == 3">
        有问题？联系客服400-900-2556
      </div>
      <div class="qrCode-iframe" v-if="type == 4">
        <iframe :src="codeUrl" frameborder="0"></iframe>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { protocolName } from "@/utils/apis";
import { mapMutations, mapState } from "vuex";
const CURRENTCOURSE = "CURRENTCOURSE";
export default {
  mixins: [],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: 1,
    },
    message: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      codeUrl: "",
    };
  },
  watch: {},
  components: {},
  mounted() {
    this.codeUrl = `https://${protocolName}.xkw.com/user/qrcode/scan-code-bind-or-verify?redirectUrl=${encodeURIComponent(
      "https://wxt.xkw.com/close-page"
    )}`;
  },
  computed: {
    ...mapState({
      currentCourse: "currentCourse",
      userInfo: "userInfo",
      userCourses: "userCourses",
      showUserCourse: "showUserCourse",
      deleteIds: "deleteIds",
    }),
  },
  methods: {
    ...mapMutations({
      setCourses: "setCourses",
      setShowUserCourse: "setShowUserCourse",
      setDeleteIds: "setDeleteIds",
      setCurrentCourse: "setCurrentCourse",
    }),
    handleJumpPage() {
      if (this.type == 2) {
        window.open(
          `https://${protocolName}.zxxk.com/login?bindingService=true&amp;service=https://auth.zxxk.com/callback`
        );
      } else {
        window.open("https://user.zxxk.com/");
      }
    },
    handleClose(e) {
      e.stopPropagation();
      this.$emit("handleClose");
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .download-error-dialog {
  .dialog-close-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 16px;
    color: #909399;
    cursor: pointer;
    z-index: 10;

    &:hover {
      color: #409eff;
    }
  }

  .el-dialog__header {
    .el-dialog__headerbtn {
      display: none;
    }
    border-bottom: none !important;
    height: auto;
    .tabheader {
      text-align: left;
      font-size: 16px;
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        font-size: 18px;
        color: #0057ff;
        margin-right: 4px;
      }
    }
  }
  .el-dialog__body {
    padding: 36px 40px;
    .dialog-body {
      text-align: center;
      p {
        font-size: 14px;
        color: #1a1a1a;
        text-align: left;
        span {
          color: #0057ff;
        }
      }
      .submit-btn {
        height: 32px;
        display: inline-block;
        line-height: 32px;
        border-radius: 6px;
        padding: 0 16px;
        background: #0057ff;
        margin: 0 auto;
        margin-top: 56px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }
      .tip {
        color: #7e7e7e;
        text-align: center;
        font-size: 12px;
        margin-top: 16px;
      }
      .qrCode-iframe {
        height: 199px;
        position: relative;
        overflow: hidden;
        margin-top: 16px;
        iframe {
          position: absolute;
          top: -73px;
          left: 0;
          right: 0;
          width: 400px;
          height: 417px;
          border: none;
          outline: none;
          margin: 0 auto;
          -webkit-transform: scale(0.7);
          -ms-transform: scale(0.7);
          transform: scale(0.7);
        }
      }
    }
  }
}
.upload-btn {
  width: 490px;
  line-height: 28px;
  border: 1px dashed #0057ff;
  border-radius: 15px;
  margin-left: 0;
  margin-top: 5px;
  color: #0057ff;
  text-align: center;
  position: relative;
  font-size: 12px;
  input {
    width: 100%;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer;
  }
  .bubble-tip {
    position: absolute;
    bottom: -33px;
    background: #ff7e07;
    padding: 0 12px;
    height: 26px;
    left: 50%;
    margin-left: -60px;
    color: #fff;
    font-size: 12px;
    line-height: 26px;
    text-align: center;
    border-radius: 5px;
    &::after {
      position: absolute;
      display: block;
      content: "";
      width: 0px;
      height: 0px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent #ff7e07 transparent;
      top: -9px;
      left: 50%;
      margin-left: -3px;
    }
  }
  i {
    font-size: 12px;
    margin-right: 10px;
  }
  &.disabled {
    border: 1px dashed #b6b9c0;
    color: #b6b9c0;
  }
}
.progress {
  position: absolute;
  top: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
  overflow: initial;
  overflow-x: initial;
}
.el-button {
  width: 132px;
  height: 42px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  &.submit {
    background: #0057ff;
    color: #fff;
    border: none;
    border-radius: 21px;
    cursor: pointer;
    margin-left: 30px;
    &.disabled {
      background: #7f848b;
      color: #fff;
    }
  }
}

::v-deep .el-dialog__header {
  text-align: left;
}
.clearfix {
  display: block;
}
// .dialog-body {
//   text-align: center;
//   font-size: 14px;
//   line-height: 24px;
//   color: #333333;
//   margin-top: 28px;
//   margin-bottom: 38px;
//   i {
//     // text
//   }
// }
</style>
